import * as Yup from 'yup';

import { accommodationIdValidationSchema, nameValidationSchema } from '../validations';

export const priceListValidationSchema = Yup.object().shape({
    name: nameValidationSchema,
    accommodationId: accommodationIdValidationSchema
});
